module.exports = __webpack_public_path__ + "static/media/02-cesar-asfor.616e7b0b.webp";